<div class="header" [hidden]="sharedService.editorFullScreen">
    <div class="left">
        <button (click)="toggleSideBar()" class="mobile-sidebar-toggler">
            <i class="far fa-bars"></i>
        </button>
        <img src="/assets/images/logo.png" />
        <span [routerLink]="['/']">Web Management</span>
    </div>
    <div class="right">
        <button [ngClass]="{ online: status === 'ONLINE', offline: status === 'OFFLINE' }">
            <i class="fas fa-circle"></i>
            <span> {{ userName.substring(0, userName.lastIndexOf('@')) }} </span>
        </button>
        <button (click)="logout()">
            <i class="fas fa-sign-out-alt"></i>
            <span> Log off </span>
        </button>
    </div>
</div>
